var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC721;}\n\t.st1{fill:#234A99;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 250,
    r: 250
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3311",
    className: "st1",
    d: "M253.3,128c-47.6,0-88.9,27.3-109,67.1H52.5l13.3,36.6h66.9h43.4h71.1h0.9v0 c9.1,0.4,16.4,7.5,17.3,16.4c0.1,0.6,0.1,1.2,0.1,1.8c0,9.8-7.7,17.8-17.4,18.3v0h-0.9h-71.1h-43.4h-52l13.4,36.6h50.2 c20.1,39.8,61.3,67.1,109,67.1c47.6,0,88.8-27.3,109-67.1h43.6l13.4-36.6H374c0.9-6,1.3-12.1,1.3-18.3c0-6.2-0.4-12.3-1.3-18.3h60.2 l13.3-36.6h-85.1C342.2,155.3,301,128,253.3,128z M253.3,170.7c43.8,0,79.3,35.5,79.3,79.3s-35.5,79.3-79.3,79.3 c-22.5,0-42.8-9.4-57.3-24.4h53.6v-0.2c1.2,0.1,2.4,0.2,3.7,0.2c30.3,0,54.9-24.6,54.9-54.9s-24.6-54.9-54.9-54.9 c-1.2,0-2.4,0-3.7,0.1v-0.1h-53.6C210.5,180,230.8,170.7,253.3,170.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMav);
export default __webpack_public_path__ + "static/media/mav.2d012d5576994fcbc37b52edfb6fd03a.svg";
export { ForwardRef as ReactComponent };